import { Context } from '@packages/layout/lib/UIShell/context';
import { useContext } from 'react';

export const useApplicationContext = () => useContext(Context);
